import axios from "axios";
import {USERS_API_BASE_URL} from "../constants";
//const BASE_URL = 'http://api.dev-n-test.com/'; // Base url for development server
//const LOCAL_BASE_URL = 'http://localhost:5050/';  // Base url for local server

export const getHelpText = (authToken) => {
    return axios.get(`${USERS_API_BASE_URL}/help`,{headers:{'Authorization':authToken}});
}
